import { render, staticRenderFns } from "./benefitsManagement.vue?vue&type=template&id=60ac592a"
import script from "./benefitsManagement.vue?vue&type=script&lang=js"
export * from "./benefitsManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports